import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfiguration } from '../../authorization/authorization';

let msalInstance: PublicClientApplication | null = null;

export const getMsalInstance = async (): Promise<PublicClientApplication> => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(getMsalConfiguration());
    await msalInstance.initialize();
  }
  return msalInstance;
};
